import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { API_CLIENT_CONFIG, AUTH_STRATEGY, ExternalAuthService, InternalAuthService } from '@xbh/common-lib';
import { providePrimeNG } from 'primeng/config';
import { environment } from '../environments/environment';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    providePrimeNG({
      unstyled: true, // デザインを完全に奪う
      theme: {
        options: {
          // CSSの優先順位を制御（Tailwindのユーティリティクラスを最強にする）
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng, tailwind-utilities',
          },
        },
      },
    }),
    {
      provide: API_CLIENT_CONFIG,
      // environment オブジェクトを型を合わせてそのまま注入する
      useValue: environment,
    },
    {
      provide: AUTH_STRATEGY,
      // isInternal の値に応じて、登録した実体サービスを切り替えて割り当てます
      useFactory: (internalAuth: InternalAuthService, externalAuth: ExternalAuthService) => {
        return environment.isInternal ? internalAuth : externalAuth;
      },
      deps: [InternalAuthService, ExternalAuthService],
    },

    InternalAuthService,
    ExternalAuthService,
  ],
};
